export enum PaymentConfigTypeEnum {
  OPEN = "open",
  FIXED = "fixed",
}
